"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _public = require("@/api/public/public");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseItem: _courseItem.default
  },
  data: function data() {
    return {
      courseList: [{
        name: '全部',
        id: ''
      }, {
        name: '公共基础',
        id: ''
      }, {
        name: '民族文化传承与创新',
        id: ''
      }, {
        name: '财经商贸大类',
        id: ''
      }, {
        name: '医药卫生大类',
        id: ''
      }, {
        name: '电子信息大类',
        id: ''
      }, {
        name: '装备制造大类',
        id: ''
      }, {
        name: '公共基础',
        id: ''
      }, {
        name: '民族文化传承与创新',
        id: ''
      }, {
        name: '财经商贸大类',
        id: ''
      }, {
        name: '医药卫生大类',
        id: ''
      }, {
        name: '电子信息大类',
        id: ''
      }, {
        name: '装备制造大类',
        id: ''
      }, {
        name: '公共基础',
        id: ''
      }, {
        name: '民族文化传承与创新',
        id: ''
      }, {
        name: '财经商贸大类',
        id: ''
      }, {
        name: '医药卫生大类',
        id: ''
      }, {
        name: '电子信息大类',
        id: ''
      }, {
        name: '装备制造大类',
        id: ''
      }],
      meititype: [{
        name: '全部',
        id: ''
      }, {
        name: '国家级项目',
        id: ''
      }, {
        name: '省级项目',
        id: ''
      }, {
        name: '院校项目',
        id: ''
      }, {
        name: '企业项目',
        id: ''
      }, {
        name: '学会项目',
        id: ''
      }],
      yingyongtype: [{
        name: '全部',
        id: ''
      }, {
        name: '专业群资源库',
        id: ''
      }],
      titleInfo: {},
      view: "1",
      bookList: [],
      leibie: {},
      total: 10,
      page: {
        pageNumber: 1,
        pageSize: 12
      }
    };
  },
  methods: {
    // 获取课程
    getCourseList: function getCourseList() {
      var _this = this;
      (0, _public.courseByCode)({
        code: this.prCode,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var list = res.data.list;
        list.forEach(function (item) {
          item.pointLike = false;
        });
        _this.bookList = list;
        _this.total = res.data.total;
      });
    },
    lookAtAll: function lookAtAll() {},
    getMajorId: function getMajorId() {},
    setsearchdata: function setsearchdata() {},
    geileibie: function geileibie() {},
    handleCurrentChange: function handleCurrentChange(e) {
      console.log(e, "curr");
      this.page.pageNumber = e;
      this.getCourseList();
    }
  },
  created: function created() {
    var v = this.$route;
    this.titleInfo.sec = v.meta.title;
    this.titleInfo.path = v.fullPath;
    this.getCourseList();
  }
};